module.exports = __webpack_public_path__ + "2496de54c10d8f589c506d6068416836.jpg";